var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.279,
    height: 19.275,
    viewBox: "0 0 19.279 19.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M9.636,6.933a4.942,4.942,0,1,0,4.942,4.942A4.934,4.934,0,0,0,9.636,6.933Zm0,8.155a3.213,3.213,0,1,1,3.213-3.213,3.219,3.219,0,0,1-3.213,3.213Zm6.3-8.357A1.153,1.153,0,1,1,14.78,5.578,1.15,1.15,0,0,1,15.933,6.731ZM19.206,7.9a5.7,5.7,0,0,0-1.557-4.039A5.742,5.742,0,0,0,13.61,2.305c-1.591-.09-6.361-.09-7.952,0A5.733,5.733,0,0,0,1.619,3.858,5.723,5.723,0,0,0,.062,7.9c-.09,1.591-.09,6.361,0,7.952a5.7,5.7,0,0,0,1.557,4.039,5.749,5.749,0,0,0,4.039,1.557c1.591.09,6.361.09,7.952,0a5.7,5.7,0,0,0,4.039-1.557,5.742,5.742,0,0,0,1.557-4.039c.09-1.591.09-6.357,0-7.948ZM17.15,17.556a3.253,3.253,0,0,1-1.832,1.832c-1.269.5-4.279.387-5.682.387s-4.417.112-5.682-.387a3.253,3.253,0,0,1-1.832-1.832c-.5-1.269-.387-4.279-.387-5.682s-.112-4.417.387-5.682A3.253,3.253,0,0,1,3.955,4.361c1.269-.5,4.279-.387,5.682-.387s4.417-.112,5.682.387A3.253,3.253,0,0,1,17.15,6.193c.5,1.269.387,4.279.387,5.682S17.653,16.292,17.15,17.556Z",
    transform: "translate(0.005 -2.238)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9672fb94d719c6b9df596921427059c0.svg";
export { ForwardRef as ReactComponent };